import { callAuthorizedGraphQLEndpoint } from '../../../../../../Module/graphQL'
import {
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM,
  PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM,
  PTO_REQUEST_STATUS_APPROVED_ENUM,
  PTO_REQUEST_STATUS_REJECTED_ENUM,
} from '../../../../../../shared/constants'

export const approveRequestGQLById = id => {
  const mutation = `
      mutation updatePersonalDataChangeRequest($input: UpdatePersonalDataChangeRequestInput!) {
          updatePersonalDataChangeRequest(input: $input) {
            success
          }
      }
  `

  const variables = {
    input: {
      id,
      status: PERSONAL_DATA_CHANGE_REQUEST_STATUS_APPROVED_ENUM,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const approveTimeOffRequestGQLById = id => {
  const mutation = `
      mutation updateTimeOffRequest($input: UpdateTimeOffRequestInput!){
        updateTimeOffRequest(input: $input){
          success
      }
    }
  `

  const variables = {
    input: {
      id,
      status: PTO_REQUEST_STATUS_APPROVED_ENUM,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const rejectTimeOffRequestGQLById = ({ id, comment }) => {
  const mutation = `
      mutation updateTimeOffRequest($input: UpdateTimeOffRequestInput!){
        updateTimeOffRequest(input: $input){
          success
      }
    }
  `
  const variables = {
    input: {
      id,
      status: PTO_REQUEST_STATUS_REJECTED_ENUM,
      rejectReason: comment,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const rejectRequestGQL = ({ id, comment }) => {
  const mutation = `
      mutation updatePersonalDataChangeRequest($input: UpdatePersonalDataChangeRequestInput!) {
          updatePersonalDataChangeRequest(input: $input) {
            success
          }
      }
  `

  const variables = {
    input: {
      id,
      comment,
      status: PERSONAL_DATA_CHANGE_REQUEST_STATUS_REJECTED_ENUM,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const addCommentGQL = ({ id, comment }) => {
  const mutation = `
      mutation updatePersonalDataChangeRequest($input: UpdatePersonalDataChangeRequestInput!) {
          updatePersonalDataChangeRequest(input: $input) {
            success
          }
      }
  `

  const variables = {
    input: {
      id,
      comment,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const addTimeOffCommentGQL = ({ id, comment }) => {
  const mutation = `
      mutation updateTimeOffRequest($input: UpdateTimeOffRequestInput!){
        updateTimeOffRequest(input: $input){
          success
      }
    }
  `

  const variables = {
    input: {
      id,
      status: PTO_REQUEST_STATUS_REJECTED_ENUM,
      rejectReason: comment,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const addTimeOffInternalCommentGQL = ({ id, internalComment }) => {
  const mutation = `
      mutation updateTimeOffRequest($input: UpdateTimeOffRequestInput!){
        updateTimeOffRequest(input: $input){
          success
      }
    }
  `

  const variables = {
    input: {
      id,
      internalComment,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const addInternalCommentGQL = ({ id, internalComment }) => {
  const mutation = `
      mutation updatePersonalDataChangeRequest($input: UpdatePersonalDataChangeRequestInput!) {
          updatePersonalDataChangeRequest(input: $input) {
            success
          }
      }
  `

  const variables = {
    input: {
      id,
      internalComment,
    },
  }

  return callAuthorizedGraphQLEndpoint(mutation, variables)
}

export const getBrandAmbassadorRequestsAndTimeOff = async ({
  ambassadorId,
}) => {
  const query = `query ($ambassadorId:ID!) {
      brandAmbassador(ambassadorId:$ambassadorId){
        personalDataChangeRequest {
          id
          userId
          oldData
          newData
          comment
          status
          type
          createdAt
          updatedAt
          editedBy
          internalComment
        }
        timeOffRequest {
            id
            userId
            timeOffType
            status 
            startDate 
            endDate 
            userComment 
            paidType
            internalComment 
            rejectReason 
            actorId 
            createdAt 
            updatedAt 
            actorName
        }
      }
    }`

  return callAuthorizedGraphQLEndpoint(query, {
    ambassadorId,
  })
}
